"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Creates a `productOption` content model
 *
 * @param {object} sys
 * @param {string} sys.id - Contentful id
 * @param {object} sys.contentType - Contentful content type
 * @param {object} sys.contentType.sys - Contentful content type sys information
 * @param {string} sys.contentType.sys.id - Contentful content type id
 * @param {object} fields - productOption fields
 * @param {string} fields.name - Product option name
 * @param {string} fields.identifier - Unique identifier for this product option
 * @param {string} fields.label - Label for the option
 * @param {string} fields.type - Type for the option
 * @param {object} fields.price - Key per currency and value as the price in cents
 * @param {boolean} fields.defaultChecked - Flags the option as checked by default
 * @param {string} fields.hintIcon - Icon to go with the hint
 * @param {object} fields.hint - Rich text hint field
 * @param {boolean} fields.inStock - Product option in stock field
 * @param {object} fields.details - Rich text details field
 * @returns `productOption` content model
 */

var createProductOption = function createProductOption(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var document = (0, _utils.getProp)(fields, 'details');
  var details = document ? (0, _processRichText["default"])({
    document: document,
    factories: _standard["default"]
  }) : null;
  var priceData = (0, _utils.getProp)(fields, 'price') || {};
  var price = priceData[process.env.NEXT_PUBLIC_SITE] || null;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    name: (0, _utils.getProp)(fields, 'name'),
    identifier: (0, _utils.getProp)(fields, 'identifier'),
    label: (0, _utils.getProp)(fields, 'label'),
    byline: (0, _utils.getProp)(fields, 'byline'),
    price: price,
    defaultChecked: (0, _utils.getProp)(fields, 'defaultChecked'),
    hintIcon: (0, _utils.getProp)(fields, 'hintIcon'),
    hint: (0, _utils.getProp)(fields, 'hint'),
    inStock: (0, _utils.getProp)(fields, 'inStock'),
    details: details
  };
};
var _default = createProductOption;
exports["default"] = _default;